import React from 'react'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'

import CustomTextField from 'components/CustomTextField'

interface VisitsFilterProps {
  visitsFilter: string | null
  setVisitsFilter: (value: string | null) => void
  visitsOperator: '==' | '>' | '<'
  setVisitsOperator: (value: '==' | '>' | '<') => void
  error: boolean
  helperText: string | undefined
  disabled?: boolean
}

const VisitsFilter: React.FC<VisitsFilterProps> = ({
  visitsFilter,
  setVisitsFilter,
  visitsOperator,
  setVisitsOperator,
  error,
  helperText,
  disabled = false,
}) => {
  const handleVisitsFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setVisitsFilter(value || null)
  }

  const handleVisitsOperatorChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setVisitsOperator(event.target.value as '==' | '>' | '<')
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel>Operador</InputLabel>
            <Select
              value={visitsOperator}
              onChange={handleVisitsOperatorChange}
              fullWidth
              defaultValue="=="
              disabled={disabled}
            >
              <MenuItem value="==">
                <Tooltip title="Igual a" placement="top-start">
                  <span style={{ width: '100%' }}>=</span>
                </Tooltip>
              </MenuItem>
              <MenuItem value=">">
                <Tooltip title="Mayor a" placement="top-start">
                  <span style={{ width: '100%' }}>&gt;</span>
                </Tooltip>
              </MenuItem>
              <MenuItem value="<">
                <Tooltip title="Menor a" placement="top-start">
                  <span style={{ width: '100%' }}>&lt;</span>
                </Tooltip>
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <CustomTextField
            label="Visitas"
            value={visitsFilter == null ? '' : visitsFilter}
            onChange={handleVisitsFilterChange}
            placeholder="Ej: 10"
            fullWidth
            inputProps={{ maxLength: 4 }}
            sanitizeValue={(text: string) => text.replace(/\D+/g, '')}
            error={error}
            helperText={helperText}
            debounceTime={400}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </>
  )
}

VisitsFilter.defaultProps = {
  disabled: false,
}

export default VisitsFilter
